import { render, staticRenderFns } from "./Synonym.vue?vue&type=template&id=3638a828&scoped=true&"
import script from "./Synonym.vue?vue&type=script&lang=js&"
export * from "./Synonym.vue?vue&type=script&lang=js&"
import style0 from "./Synonym.vue?vue&type=style&index=0&id=3638a828&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3638a828",
  null
  
)

export default component.exports